// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__MOFZ6 {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
@media (min-width: 320px) {
  .Footer_footer__MOFZ6 {
    min-height: auto;
    height: auto;
    position: relative;
    flex-direction: column;
    text-align: center;
    padding: 0;
    gap: 0;
  }
}
@media (min-width: 720px) {
  .Footer_footer__MOFZ6 {
    position: fixed;
    height: 67px;
    flex-direction: row;
    text-align: left;
    padding: 20px 30px;
  }
}

.Footer_copyright__H9Nzf {
  margin-top: 5px;
  font-size: 12px;
  color: #ccc;
}
@media (min-width: 320px) {
  .Footer_copyright__H9Nzf {
    margin-top: 15px;
  }
}
@media (min-width: 720px) {
  .Footer_copyright__H9Nzf {
    margin-top: 5px;
  }
}

.Footer_nav__yKGFF {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: row;
}
@media (min-width: 320px) {
  .Footer_nav__yKGFF {
    gap: 0;
    flex-direction: column;
    font-size: 1.2em;
  }
}
@media (min-width: 720px) {
  .Footer_nav__yKGFF {
    gap: 10px;
    flex-direction: row;
    font-size: 1em;
  }
}
.Footer_nav__yKGFF .Footer_links__WTkFA {
  display: flex;
  margin-top: 20px;
  gap: 20px;
}
@media (min-width: 320px) {
  .Footer_nav__yKGFF .Footer_links__WTkFA {
    gap: 5px;
    flex-direction: column;
    line-height: 20px;
  }
}
@media (min-width: 720px) {
  .Footer_nav__yKGFF .Footer_links__WTkFA {
    gap: 10px;
    flex-direction: row;
  }
}
@media (min-width: 320px) {
  .Footer_nav__yKGFF .Footer_links__WTkFA button span {
    display: inline;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Footer/Footer.module.scss","webpack://./src/_common/scss/_media.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAIA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAHF;ACMI;EDPJ;IAOI,gBAAA;IACA,YAAA;IACA,kBAAA;IACA,sBAAA;IACA,kBAAA;IACA,UAAA;IACA,MAAA;EAFF;AACF;ACGI;EDfJ;IAiBI,eAAA;IACA,YESY;IFRZ,mBAAA;IACA,gBAAA;IACA,kBAAA;EADF;AACF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,WAAA;AADF;ACpBI;EDkBJ;IAMI,gBAAA;EAAF;AACF;ACjBI;EDUJ;IAUI,eAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;ACrCI;EDgCJ;IAOI,MAAA;IACA,sBAAA;IACA,gBAAA;EAEF;AACF;ACpCI;EDwBJ;IAaI,SAAA;IACA,mBAAA;IACA,cAAA;EAGF;AACF;AADE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AAGJ;ACxDI;EDkDF;IAMI,QAAA;IACA,sBAAA;IACA,iBAAA;EAIJ;AACF;ACvDI;ED0CF;IAYI,SAAA;IACA,mBAAA;EAKJ;AACF;ACrEI;EDmEE;IACE,eAAA;EAKN;AACF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  @include media(xss) {\n    min-height: auto;\n    height: auto;\n    position: relative;\n    flex-direction: column;\n    text-align: center;\n    padding: 0;\n    gap: 0;\n  }\n\n  @include media(sm) {\n    position: fixed;\n    height: $navbar-height;\n    flex-direction: row;\n    text-align: left;\n    padding: $padding-l $padding-xl;\n  }\n}\n\n.copyright {\n  margin-top: 5px;\n  font-size: 12px;\n  color: #ccc;\n\n  @include media(xss) {\n    margin-top: 15px;\n  }\n\n  @include media(sm) {\n    margin-top: 5px;\n  }\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-direction: row;\n\n  @include media(xss) {\n    gap: 0;\n    flex-direction: column;\n    font-size: 1.2em;\n  }\n\n  @include media(sm) {\n    gap: 10px;\n    flex-direction: row;\n    font-size: 1em;\n  }\n\n  & .links {\n    display: flex;\n    margin-top: 20px;\n    gap: 20px;\n\n    @include media(xss) {\n      gap: 5px;\n      flex-direction: column;\n      line-height: 20px;\n    }\n\n    @include media(sm) {\n      gap: 10px;\n      flex-direction: row;\n    }\n\n    @include media(xss) {\n      & button span {\n        display: inline;\n      }\n    }\n  }\n}\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__MOFZ6`,
	"copyright": `Footer_copyright__H9Nzf`,
	"nav": `Footer_nav__yKGFF`,
	"links": `Footer_links__WTkFA`
};
export default ___CSS_LOADER_EXPORT___;
